import React, { useEffect } from 'react';
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Form,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Tooltip
} from "reactstrap";

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// services
import { showMessage } from "services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";

import { useAuth } from 'context/auth.js';

export default function CadastroDocumentos({ history }) {
  const {session, setLoading} = useAuth();

  const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });
  const [permiteEditar, set_permiteEditar] = React.useState(false);

  const [status, set_status] = React.useState("");
  const [options_status] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  }

  const [rowEdit, set_rowEdit] = React.useState(null);
  const [openCollapse, set_openCollapse] = React.useState(false);
  const [list_table, set_list_table] = React.useState([]);

  const loadList = () => {
    set_openCollapse(false);
    set_rowEdit(null);
    setLoading(true);
    api_GET('documento')
      .then(result => set_list_table(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  const handleAdd = () => {
    set_rowEdit(null);
    setValue("descricao", "");
    setValue("orientacao", "");
    setValue("status", "", false);
    set_status("");
    set_openCollapse(true);
  }

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    setValue("descricao", rowData.descricao);
    setValue("orientacao", rowData.orientacao);
    setValue("status", rowData.status, false);
    handleStatus(rowData.status);
    set_openCollapse(true);
  }

  const onSubmit = (data) => {

    let json_submit = {
      documento_Id: rowEdit != null ? rowEdit.documento_Id : 0,
      descricao: data.descricao,
      orientacao: data.orientacao,
      status: status,
      usuarioCadastro_Id: session.usuario_Id,
      UsuarioUltimaAlteracao_Id: session.usuario_Id
    }

    setLoading(true);
    if (json_submit.documento_Id == 0) {
      api_POST('documento', json_submit).then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList(); }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false));
    }
    else {
      api_PUT('documento', json_submit)
        .then(result => () => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList(); }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false));
    }
  }

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("CadastroDocumentos.Editar", function (result) { set_permiteEditar(result) });
    loadList();
  }, []);

  return (
    <>
      <div className="content">
        <button type="button" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Documento</button>
        <Collapse isOpen={openCollapse} defaultOpen={false}>
          <Row>
            <Col md="12">
              <Card className="card-user">
                <CardHeader>
                  <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                </CardHeader>
                <CardBody style={{ minHeight: "auto" }}>
                  <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md="10" sm="12">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Descrição</label></b>
                          <Input type="text" name="descricao" maxLength={100} innerRef={register({ required: true })} />
                          {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="2" sm="6">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Status</label></b>
                          <Select
                            options={options_status}
                            name="status"
                            onChange={(e) => { handleStatus(e.value) }}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                            value={status != "" && options_status.find(obj => obj.value === status)}
                            placeholder="Selecione"
                            ref={e => register(
                              { name: "status" },
                              { required: true })
                            }
                          />
                          {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="12" sm="12">
                        <b><label>Orientação</label></b>
                        <FormGroup>
                          <Input type="textarea" name="orientacao" maxLength={800} innerRef={register()} />
                        </FormGroup>
                      </Col>
                      <Col className="text-center" md="12" sm="2">
                        <FormGroup>
                          <Button disabled={!permiteEditar} color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Collapse>
        <Row>
          <Col md="12">
            <MaterialTable style={{ minHeight: "auto" }}
              title=""

              columns={[
                { title: 'Descrição', field: 'descricao' },
                { title: 'Status', field: 'status' },
              ]}
              data={list_table}
              isLoading={false}
              options={{
                ...table_style,
                filtering: false,
                exportButton: true
              }}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Editar Registro',
                  onClick: (event, rowData) => handleEdit(rowData)
                }
              ]}
              localization={table_translate}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}